module.exports = __webpack_public_path__ + "static/media/2023-VC-Feature-Banner-Mobile@2x.f27bc2d7.jpg";